import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  main: {
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.palette.info.main,
  },
  container: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: 488,
    padding: 32,
    textAlign: 'center',
    borderRadius: 4,
    boxShadow: '0 6px 8px 0 rgba(0,0,0,0.1)',
    background: theme.palette.info.light,
  },
  form: {
    width: '100%',
  },
  formWrap: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'stretch',
  },
  formControl: {
    width: '100%',
    paddingTop: 18,
  },
  label: {
    fontSize: 14,
    transform: 'none',
    opacity: '0.6',
    color: theme.palette.primary.light,
    paddingBottom: 10,
    position: 'relative',
    textAlign: 'left',
  },
  inputWrap: {
    maxHeight: 93,
  },
  input: {
    fontSize: 50,
    padding: 0,
  },
  formBottom: {
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: 18,
  },
  forgotPass: {
    color: theme.palette.secondary.main,
    fontSize: 14,
    fontWeight: 500,
    cursor: 'pointer',
    textAlign: 'left',
    opacity: '87%',
  },
  link: {
    textDecoration: 'none',
  },
  errorField: {
    color: theme.palette.error.main,
    fontSize: 12,
    textAlign: 'left',
    paddingTop: 2,
  },
}))

export default useStyles
